module.exports = __webpack_public_path__ + "img/info_9.3fdc247e.jpeg";